<template>
  <div class="invoices">
    <div class="main-actions">
      <button class="floater" @click="addInvoice()"><i class="far fa-plus"></i></button>
    </div>
    <div class="content">
      <invoice-list :invoices="invoices" :clients="clients" class="invoice-list"></invoice-list>
      <invoice-form v-if="selectedInvoice" :rawInvoice="selectedInvoice" class="invoice-form"></invoice-form>
      <invoice-template v-if="selectedInvoice" :invoice="selectedInvoice" class="invoice-selected  a4"></invoice-template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import InvoiceList from "@/components/invoice/InvoiceList";
import InvoiceTemplate from "@/components/invoice/InvoiceTemplate";
import InvoiceForm from "@/components/invoice/InvoiceForm";
import { mapGetters } from "vuex"
export default {
  name: "Invoices",
  components: {
    InvoiceList,
    InvoiceTemplate,
    InvoiceForm
  },
  data() {
    return {
      moment: moment,
      url: "",
      id: this.$route.params.id
    };
  },
  created() {
    if (this.id) {
      this.$store.dispatch('setSelectedInvoice', {invoice : this.id})
    }
  },
  computed: {
    ... mapGetters(["invoices", "selectedInvoice", "clients"])
  },
  methods: {
    addInvoice() {
      let number = "1"
      if(this.invoices.length > 0){
        number = (parseInt(this.invoices[Object.keys(this.invoices)[0]].number) + 1).toString()
      }
      let newInvoice = {
        date: new Date(),
        index: this.invoices.length,
        number: number,
        status: "new",
        vat_percentage: 21,
        payment_period: 30,
        articles: [],
        client_id: null,
        template: null
      }
      this.$store.dispatch('addInvoice', newInvoice)
    }
  }
};
</script>


<style lang="scss" scoped>
.content {
  display: flex;
  .invoice-selected {
    margin-right: 10px;
  }
}

@media print {
  .main-actions {
    display: none;
  }
}
</style>
